import { useMutation, useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "./client";

export const useAdsAuthorisation = (authorisationId: string) => {
  return useQuery({
    queryKey: ["ads-auth", authorisationId],
    queryFn: async () => {
      const res = await client["ads-auth"][":authorisationId"].$get({ param: { authorisationId } });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    enabled: !!authorisationId,
    retry: false,
  });
};

export const useSelectAdsAdvertiser = (authorisationId: string) => {
  return useMutation({
    mutationFn: async (advertiserId: string) => {
      const res = await client["ads-auth"][":authorisationId"]["select-advertiser"].$post({
        param: { authorisationId },
        json: { advertiserId },
      });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
  });
};
